import React from 'react';
import './testimonials.css';
import Client1 from '../../components/clients/assets/Navidea_logo_hiRes.jpg'
import Client2 from '../../components/clients/assets/jll_logo_detail.png'

function Testimonials () {

  return (  
    <div className='testimonials-wrapper'>
      <div className='company-wrapper'>
        <img src={ Client1 } alt='company logo'/>
        <p className='company-testimonial'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        </div>
        <div className='company-wrapper'>
        <img src={ Client2 } alt='company logo'/>
        <p className='company-testimonial'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        </div>
    </div>
  );
}

export default Testimonials;